// Runder Typ-Kreis wie in Close: orange Haken = Aufgabe, rosa Pfeil = verpasster Anruf, grünes Telefon = angenommen,
// Sprechblase = SMS, Pokal = Opportunity. Der Kreis ist zugleich der Erledigen-Knopf (Hover zeigt den Haken).
import type { AufgabeArt } from "./typen";
import "./inbox.css";

const PFADE: Record<AufgabeArt, string> = {
  aufgabe: "M5 12.5l4.5 4.5L19 7",
  anruf: "M5 4h3l2 5-2 1a11 11 0 006 6l1-2 5 2v3a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z",
  verpasst: "M17 7L7 17M15 17H7V9",
  angenommen: "M5 4h3l2 5-2 1a11 11 0 006 6l1-2 5 2v3a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z",
  voicemail: "M6 15a3 3 0 100-6 3 3 0 000 6zM18 15a3 3 0 100-6 3 3 0 000 6zM6 15h12",
  sms: "M4 5h16v11H9l-5 4z",
  opportunity: "M8 4h8v5a4 4 0 01-8 0zM8 6H5v1a3 3 0 003 3M16 6h3v1a3 3 0 01-3 3M12 13v4M9 20h6",
};
const HAKEN = PFADE.aufgabe;

export const ART_LABEL: Record<AufgabeArt, string> = {
  aufgabe: "Aufgabe",
  anruf: "Anrufaufgabe",
  verpasst: "Verpasster Anruf",
  angenommen: "Angenommener Anruf",
  voicemail: "Voicemail",
  sms: "SMS",
  opportunity: "Opportunity",
};

function Strich({ d }: { d: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={d} />
    </svg>
  );
}

/** Inhalt des Kreises: Symbol der Art, bei Hover (oder erledigt) der Haken. */
export function TypSymbol({ art, erledigt }: { art: AufgabeArt; erledigt: boolean }) {
  if (erledigt || art === "aufgabe") return <Strich d={HAKEN} />;
  return (
    <>
      <span className="typ-symbol typ-symbol--art">
        <Strich d={PFADE[art]} />
      </span>
      <span className="typ-symbol typ-symbol--haken">
        <Strich d={HAKEN} />
      </span>
    </>
  );
}
